/* RCP Chat v6 — typewriter queue */
(function () {
  var RCP_API = 'https://corebuild-platform-production.up.railway.app/api/chat-proxy/stream';

  // ── Persistent session ID ──
  var SESSION_KEY = 'rcp_chat_session';
  function getSessionId() {
    try {
      var sid = localStorage.getItem(SESSION_KEY);
      if (!sid) {
        sid = 'web-' + Math.random().toString(36).slice(2, 10) + '-' + Date.now().toString(36);
        localStorage.setItem(SESSION_KEY, sid);
      }
      return sid;
    } catch(e) {
      if (!getSessionId._fallback) {
        getSessionId._fallback = 'web-' + Math.random().toString(36).slice(2, 10) + '-' + Date.now().toString(36);
      }
      return getSessionId._fallback;
    }
  }
  var sessionId = getSessionId();

  // ── Inject animated typing indicator CSS once ──
  (function injectCSS() {
    if (document.getElementById('rcp-typing-style')) return;
    var style = document.createElement('style');
    style.id = 'rcp-typing-style';
    style.textContent = [
      '@keyframes rcp-blink {',
      '  0%,80%,100% { opacity: 0.15; transform: scale(0.8); }',
      '  40% { opacity: 1; transform: scale(1); }',
      '}',
      '.rcp-typing-dot {',
      '  display: inline-block;',
      '  width: 7px; height: 7px;',
      '  border-radius: 50%;',
      '  background: currentColor;',
      '  margin: 0 2px;',
      '  animation: rcp-blink 1.2s infinite ease-in-out;',
      '}',
      '.rcp-typing-dot:nth-child(2) { animation-delay: 0.2s; }',
      '.rcp-typing-dot:nth-child(3) { animation-delay: 0.4s; }'
    ].join('');
    document.head.appendChild(style);
  })();

  function makeTypingBubble() {
    var w = document.createElement('div'); w.className = 'rcp-msg rcp-bot';
    var b = document.createElement('div'); b.className = 'rcp-bubble';
    b.innerHTML = '<span class="rcp-typing-dot"></span><span class="rcp-typing-dot"></span><span class="rcp-typing-dot"></span>';
    w.appendChild(b);
    return { wrap: w, bubble: b };
  }

  function wireChat(input, sendBtn, msgs) {
    if (!input || !sendBtn || !msgs) return;
    if (input._rcpWired) return;
    input._rcpWired = true;

    var history = [], busy = false;
    var customerName = '', customerEmail = '', customerPhone = '';

    function extractIdentity(text) {
      var emailMatch = text.match(/[\w.+-]+@[\w-]+\.[a-z]{2,}/i);
      if (emailMatch && !customerEmail) customerEmail = emailMatch[0];
      var phoneMatch = text.match(/\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}/);
      if (phoneMatch && !customerPhone) customerPhone = phoneMatch[0].replace(/\D/g,'');
    }

    function scrollDown() { msgs.scrollTop = msgs.scrollHeight; }

    function bubble(role, text) {
      var w = document.createElement('div'); w.className = 'rcp-msg rcp-' + role;
      var b = document.createElement('div'); b.className = 'rcp-bubble';
      if (role === 'bot') {
        b.innerHTML = text.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
          .replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>').replace(/\n/g,'<br>');
      } else { b.textContent = text; }
      w.appendChild(b); msgs.appendChild(w); scrollDown();
      return b;
    }

    function send() {
      if (busy) return;
      var text = input.value.trim(); if (!text) return;
      input.value = ''; input.style.height = 'auto';
      busy = true; sendBtn.disabled = true;

      extractIdentity(text);
      bubble('user', text);
      history.push({ role: 'user', content: text });

      // Show animated typing indicator immediately
      var typing = makeTypingBubble();
      msgs.appendChild(typing.wrap); scrollDown();

      var streamedText = '';
      var firstToken = true;
      var tokenQueue = [], draining = false;

      function renderQueued() {
        var tok = tokenQueue.shift();
        streamedText += tok;
        typing.bubble.innerHTML = streamedText
          .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
          .replace(/\*\*(.+?)\*\*/g,'<strong>$1</strong>')
          .replace(/\n/g,'<br>');
        scrollDown();
      }

      function drainQueue() {
        if (tokenQueue.length === 0) { draining = false; return; }
        draining = true;
        renderQueued();
        setTimeout(drainQueue, 18);
      }

      function flushQueue() {
        while (tokenQueue.length) renderQueued();
        draining = false;
      }

      var payload = {
        sessionId: sessionId,
        messages: history.slice(-20),
        customerName: customerName || undefined,
        customerEmail: customerEmail || undefined,
        customerPhone: customerPhone || undefined
      };

      fetch(RCP_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-company-slug': 'rcp' },
        body: JSON.stringify(payload)
      }).then(function(resp) {
        if (!resp.ok || !resp.body) throw new Error('Stream unavailable');
        var reader = resp.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';

        function readChunk() {
          reader.read().then(function(result) {
            if (result.done) {
              busy = false; sendBtn.disabled = false; input.focus();
              return;
            }
            buffer += decoder.decode(result.value, { stream: true });
            var parts = buffer.split('\n\n');
            buffer = parts.pop();

            parts.forEach(function(part) {
              var line = part.replace(/^data:\s*/, '').trim();
              if (!line) return;
              try {
                var obj = JSON.parse(line);

                // thinking frame: server confirmed receipt, keep showing animated dots
                if (obj.thinking) return;

                if (obj.token !== undefined) {
                  // First real token — replace animated dots with text bubble
                  if (firstToken) {
                    firstToken = false;
                    typing.bubble.innerHTML = '';
                  }
                  var tok = String(obj.token)
                    .replace(/```order[\s\S]*?```/gi,'')
                    .replace(/\[(CONFIRM_ORDER|INFO_COMPLETE|PLAN_TAKEOFF[^\]]*|CALC_DELIVERY[^\]]*|LOOKUP_CUSTOMER[^\]]*|ESTIMATE_READY|CONFIRM_ESTIMATE)\]/g,'');
                  if (tok) {
                    // Queue token for rendering — drain queue at typewriter pace (20ms/token)
                    tokenQueue.push(tok);
                    if (!draining) drainQueue();
                  }
                }

                if (obj.done) {
                  var meta = obj.meta || {};
                  // Flush any remaining queued tokens instantly before showing cards
                  flushQueue();
                  history.push({ role: 'assistant', content: streamedText });
                  extractIdentity(streamedText);
                  busy = false; sendBtn.disabled = false; input.focus();

                  // Estimate card
                  if (meta.estimateNumber) {
                    var estWrap = document.createElement('div'); estWrap.className = 'rcp-msg rcp-bot';
                    var estBub = document.createElement('div'); estBub.className = 'rcp-bubble';
                    var emailNote = customerEmail ? 'A copy has been emailed to ' + customerEmail + '.' : 'A copy has been sent to your email.';
                    var pdfBtnHtml = meta.estimateId ? '<div style="margin-top:10px;"><a href="https://corebuild-platform-production.up.railway.app/api/estimate-pdf/' + meta.estimateId + '" target="_blank" rel="noopener" style="display:inline-block;background:#C8D400;color:#16161d;font-weight:700;padding:10px 20px;border-radius:20px;text-decoration:none;font-size:14px;">&#x21E9; Download PDF</a></div>' : '';
                    estBub.innerHTML = '<div style="margin-bottom:8px;font-weight:600;">Estimate #' + meta.estimateNumber + ' is ready!</div>' + pdfBtnHtml + '<div style="margin-top:8px;font-size:13px;opacity:0.75;">' + emailNote + '</div>';
                    estWrap.appendChild(estBub); msgs.appendChild(estWrap); scrollDown();
                  }

                  // Invoice/payment card
                  if (meta.paymentLink && meta.invoiceNumber) {
                    var pWrap = document.createElement('div'); pWrap.className = 'rcp-msg rcp-bot';
                    var pBub = document.createElement('div'); pBub.className = 'rcp-bubble';
                    pBub.innerHTML = '<div style="margin-bottom:8px;font-weight:600;">Invoice #' + meta.invoiceNumber + ' is ready!</div><a href="' + meta.paymentLink + '" target="_blank" rel="noopener" style="display:inline-block;background:#C8D400;color:#16161d;font-weight:700;padding:10px 20px;border-radius:20px;text-decoration:none;font-size:14px;">Pay Invoice &rarr;</a>';
                    pWrap.appendChild(pBub); msgs.appendChild(pWrap); scrollDown();
                  }

                  if (obj.error) {
                    typing.wrap.remove(); bubble('bot','Something went wrong. Call 469-631-7730.');
                    busy = false; sendBtn.disabled = false; input.focus();
                  }
                }

              } catch(e) { /* malformed SSE line — skip */ }
            });

            readChunk();
          }).catch(function() {
            typing.wrap.remove(); bubble('bot','Connection error. Call 469-631-7730.');
            busy = false; sendBtn.disabled = false; input.focus();
          });
        }
        readChunk();
      }).catch(function() {
        typing.wrap.remove(); bubble('bot','Connection error. Call 469-631-7730.');
        busy = false; sendBtn.disabled = false; input.focus();
      });
    }

    sendBtn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); send(); });
    input.addEventListener('keydown', function(e){
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); e.stopPropagation(); send(); }
    });
    input.addEventListener('input', function(){
      this.style.height = 'auto';
      this.style.height = Math.min(this.scrollHeight, 100) + 'px';
    });
  }

  /* ── Mobile overlay open/close ── */
  function wireMobileOverlay() {
    var overlay  = document.getElementById('rcp-mobile-chat-overlay');
    var openBtn  = document.getElementById('rcp-mobile-ai-btn');
    var closeBtn = document.getElementById('rcp-mobile-chat-close');
    var chipsBar = document.getElementById('rcp-mobile-chat-chips');
    var chips    = document.querySelectorAll('.rcp-mobile-chip');

    if (!overlay || !openBtn) return;

    function openMobileChat() {
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      setTimeout(function(){
        var inp = document.getElementById('rcp-mobile-chat-input');
        if (inp) inp.focus();
      }, 100);
    }
    function closeMobileChat() {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openMobileChat);
    if (closeBtn) closeBtn.addEventListener('click', closeMobileChat);
    overlay.addEventListener('click', function(e){
      if (e.target === overlay) closeMobileChat();
    });

    chips.forEach(function(chip){
      chip.addEventListener('click', function(){
        var msg = chip.getAttribute('data-msg');
        if (!msg) return;
        if (chipsBar) chipsBar.style.display = 'none';
        var inp = document.getElementById('rcp-mobile-chat-input');
        if (inp) { inp.value = msg; inp.dispatchEvent(new Event('input')); }
        var sb = document.getElementById('rcp-mobile-chat-send');
        if (sb) sb.click();
      });
    });
  }

  function init() {
    wireChat(
      document.getElementById('rcp-chat-input'),
      document.getElementById('rcp-chat-send'),
      document.getElementById('rcp-chat-messages')
    );
    wireChat(
      document.getElementById('rcp-mobile-chat-input'),
      document.getElementById('rcp-mobile-chat-send'),
      document.getElementById('rcp-mobile-chat-messages')
    );
    wireMobileOverlay();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
